import request from './request'

export function login (payload) {
  return request.post('/auth/login', payload)
}
